import React from 'react';
import { IconButton, Typography } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import moment from 'moment';

const CustomToolbar = ({ label, onNavigate, date, onView, views, view }) => {
  const goToBack = () => {
    onNavigate('PREV', new Date('01-04-2000'));
  };

  const goToNext = () => {
    onNavigate('NEXT');
  };

  const goToToday = () => {
    onNavigate('TODAY');
  };

  return (
    <div style={toolbarStyle}>
      <IconButton onClick={goToBack}>
        <ArrowLeftIcon />
      </IconButton>
      <Typography variant="h6">{moment(date).format('MMM YY')}</Typography>
      <IconButton onClick={goToNext}>
        <ArrowRightIcon />
      </IconButton>

    </div>
  );
};

const toolbarStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px',
  border: 'none',
};

export default CustomToolbar;